<template>
  <div>
    <h2>Aprovar Notas Fiscais de Serviço</h2>
    <div class="d-flex w-100 gap-10 search-form">
      <form class="w-100 flex-grow-1 d-flex justify-center align-baseline" @submit.prevent="getItensOs">
        <v-row no-gutters style="gap: 15px;">
          <v-text-field
            cols="6"
            class="pt-5 pb-5"
            chips
            v-model="filter.search"
            clearable
            hide-details
            hide-selected
            prepend-icon="mdi-magnify"
            label="Pesquisa"
            solo
          />
          <v-btn type="submit" color="primary" large class="mt-5">Buscar</v-btn>
        </v-row>

      </form>

      <div class="text-center mb-1">
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              v-on="on" 
              large
              :disabled="selected.length == 0"
            >
              Ações
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in actionsMassa"
              :key="index"
              :value="index"
              @click="item.handle"
              class="cursor-pointer"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>

        </v-menu>
      </div>
    </div>
    
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      class="elevation-1 mt-10"
      disable-sort
      hide-default-footer
      :page.sync="page"
      item-value="name"
      show-select            
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      return-object
    >
    
    <template v-slot:header:[`data-table-select`]>
      <v-checkbox disabled />
    </template>
    
    <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" style="display: flex; justify-content: center;">
            <v-checkbox
            :input-value="isSelected"
            @click.stop="select(!isSelected)"
            />
          </div>
        </template>
      </v-tooltip>
    </template>
        
    <template v-slot:[`item.simplesNacional`]="{ item }">
      <span>
        {{ item.simplesNacional ? 'Sim' : 'Não' }}
      </span>
    </template>

    <template v-slot:[`item.vlrLiquido`]="{ item }">
      <span>
        {{
          item.vlrLiquido.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
      </span>
    </template>

    <template v-slot:[`item.vlrTotal`]="{ item }">
      <span>
        {{
          item.vlrTotal.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          })
        }}
      </span>
    </template>
        
    <template v-slot:[`item.dataEmissao`]="{ item }">
      <span>
        {{ moment(item.dataEmissao).format("DD/MM/YYYY HH:mm:ss") }}
      </span>
    </template>

    <template v-slot:[`item.dataVenc`]="{ item }">
      <span>
        {{ moment(item.dataVenc).format("DD/MM/YYYY HH:mm:ss") }}
      </span>
    </template>

    </v-data-table>
    
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        @input="pagination"
      ></v-pagination>
    </div>
    <v-dialog v-model="openModalApproveItems" max-width="500px" content-class="dialog-approve-nf">
      <v-card>
        <v-card-title>Aprovar Notas Selecionadas?</v-card-title>
        <v-card-actions class="justify-end">
          <v-btn text @click="openModalApproveItems = false">Cancelar</v-btn>
          <v-btn color="primary" @click="updateNotas">Aprovar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AprovarNotasFiscaisDeServicoReprovarNotasModal @cancel="handleCancelRefuseModal" @close="handleCloseRefuseModal" :nfItens="selected" :value="openModalRejectItems" />
  </div>
</template>

<script>
import Vue from 'vue';
import EntityService from "@/services/entityService.js";
import moment from 'moment';
import AprovarNotasFiscaisDeServicoReprovarNotasModal from './AprovarNotasFiscaisDeServicoReprovarNotasModalView.vue'
//import UtilNumber from '../../utils/UtilNumber';

export default {
  name: 'AprovarNotasFiscaisDeServico',
  components: {
    AprovarNotasFiscaisDeServicoReprovarNotasModal
  },
  data() {
    return {
      filter: {
        search: ''
      },
      selected: [],
      entityService: new EntityService('FisDocService'),
      items: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 0,
      moment: moment,
      openModalRejectItems: false,
      openModalApproveItems: false,
      headers: [
        { text: "Número", value: "numero" },
        { text: "Descrição", value: "descricao" },
        { text: "Valor Líquido", value: "vlrLiquido"},
        { text: "Valor Total", value: "vlrTotal" },
        { text: "Simples Nacional", value: "simplesNacional" },
        { text: "Data Emissão", value: "dataEmissao" },
        { text: "Data Vencimento", value: "dataVenc" }
      ],
      actionsMassa: [
        { 
          title: 'Aprovar Notas',
          handle: () => {
            this.openModalApproveItems = true
          }
        },
        { 
          title: 'Reprovar Notas',
          handle: () => {
            this.openModalRejectItems = true
          }
        },
      ],
    }
  },

  methods: {
    async getItensOs(){
      const response = await this.entityService.getAll(1, 30, `[${this.filter.search ?? ''}],[Aguardando Aprovação]`, '[numero],[status]', null, null, null)
      this.items = response.data.data.data
      this.pageCount = response.data.data.pages
      this.itemsPerPage = response.data.data.limit
    },

    async handleCloseRefuseModal() {
      this.openModalRejectItems = false;
      this.selected = [];
      this.getItensOs();
    },

    async handleCancelRefuseModal(){
      this.openModalRejectItems = false;
    },

    async updateNotas() {
      
      const payload = []
      for(const item of this.selected) {
        const {
          updateAt,
          updateBy,
          deleteAt,
          deleteBy,
          isDeleted,
          createAt,
          createBy,
          ...rest
        } = item;
      

        payload.push({
          ...rest,
          status: 'Aprovado',
        });
      }

      await Vue.prototype.$http.put(`/Entity/updateMany/FisDocService`, payload);

      Vue.prototype.$notify({
        title: "Notas Aprovadas com Sucesso!",
        closeOnClick: true,
        duration: 3000,
        positions: "right",
        type: "success",
      });

      this.openModalApproveItems = false
      
      this.getItensOs();
    },

    pagination(page) {
      this.page = page
      this.getItensOs()
    },
  },

  async created(){
    await this.getItensOs()
  }
}
</script>


<style scoped>
  .container {
    width: '100%'
  }

  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .search-form {
    gap: 10px;
    align-items: center;
  }
</style>